import React from "react";
import Drag_pan from "../../Atomos/Icons/Drag_pan";
import chevronRightButton from "../../../assets/Fonts/chevron-right-button.svg";
import LegacyButton from "../../Atomos/Buttons/LegacyButton";
interface IButtons {
  name: string;
  action: () => void;
  color?: "primary" | "accent";
  className?: string;
}
export interface CardProps {
  title: string;
  index: number;
  onDragStart: (
    event: React.DragEvent<HTMLDivElement>,
    position: number
  ) => void;
  onDrop: (event: React.DragEvent<HTMLDivElement>, newPosition: number) => void;
  children?: React.ReactNode;
  buttons?: IButtons[];
  treatSingleButtonAsPrimary?: boolean;
  heightClassName?: string;
}

const sanitizeCarouselPreview = (dragImage: HTMLElement) => {
  dragImage.querySelectorAll(".react-multi-carousel-list").forEach((list) => {
    (list as HTMLElement).style.overflow = "hidden";
  });

  dragImage.querySelectorAll(".react-multi-carousel-track").forEach((track) => {
    const trackElement = track as HTMLElement;
    const items = Array.from(
      trackElement.querySelectorAll(".react-multi-carousel-item"),
    ) as HTMLElement[];
    const activeItems = items.filter((item) =>
      item.classList.contains("react-multi-carousel-item--active"),
    );

    if (activeItems.length === 0) {
      return;
    }

    items.forEach((item) => {
      if (!item.classList.contains("react-multi-carousel-item--active")) {
        item.remove();
      }
    });

    trackElement.style.transform = "translate3d(0px, 0px, 0px)";
    trackElement.style.transition = "none";
  });
};

const EventCard: React.FC<CardProps> = ({
  title,
  index,
  onDragStart,
  onDrop,
  children,
  buttons,
  treatSingleButtonAsPrimary,
  heightClassName = "min-h-[34rem]",
}) => {
  if (treatSingleButtonAsPrimary === undefined) {
    treatSingleButtonAsPrimary = true;
  }

  const handleDragStart = (e: React.DragEvent<HTMLDivElement>) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const dragImage = e.currentTarget.cloneNode(true) as HTMLElement;

    sanitizeCarouselPreview(dragImage);

    dragImage.style.position = "absolute";
    dragImage.style.top = "-1000px";
    dragImage.style.left = "-1000px";
    dragImage.style.width = `${rect.width}px`;
    dragImage.style.height = `${rect.height}px`;
    dragImage.style.backgroundColor = "white";
    dragImage.style.border = "1px solid #ccc";
    dragImage.style.borderRadius = "8px";
    dragImage.style.boxShadow = "0 4px 8px rgba(0,0,0,0.1)";
    dragImage.style.opacity = "0.9";
    dragImage.style.zIndex = "1000";
    dragImage.style.overflow = "hidden";
    dragImage.style.pointerEvents = "none";

    document.body.appendChild(dragImage);

    const offsetX = Math.min(Math.max(e.clientX - rect.left, 0), rect.width);
    const offsetY = Math.min(Math.max(e.clientY - rect.top, 0), rect.height);
    e.dataTransfer.setDragImage(dragImage, offsetX, offsetY);

    window.setTimeout(() => {
      if (document.body.contains(dragImage)) {
        document.body.removeChild(dragImage);
      }
    }, 50);

    onDragStart(e, index);
  };

  return (
    <div
      draggable
      onDragStart={handleDragStart}
      onDragOver={(e) => e.preventDefault()}
      onDrop={(e) => onDrop(e, index)}
      className={
        `flex flex-col self-stretch bg-white w-full col-span-2 lg:col-span-1 ${heightClassName}`
      }
    >
      <div
        className={`flex text-gray-font text-xl font-medium font-sans cursor-grab bg-primary`}
      >
        <span className="sm:text-2xl text-xl font-medium px-5 py-4 flex-1 desimal_Mediu font-decimal text-white break-words overflow-hidden">
          {title}
        </span>
        <div
          className={`bg-primary-dark text-[#702216] flex items-center justify-center w-18 px-5 py-4 flex-shrink-0`}
        >
          <Drag_pan color="#702216" className="w-8 h-8" />
        </div>
      </div>

      <div className={`p-5 flex-1 text-start`}>
        {children}
      </div>

      <div className="px-3">
        <div
          className={`flex gap-2 w-full px-2 py-2 ${
            buttons?.length === 1 && !treatSingleButtonAsPrimary
              ? "flex-row justify-end"
              : "flex-col-reverse sm:flex-row justify-between"
          }`}
        >
          {buttons?.map((button, index) => {
            const isOnlyButton = buttons.length === 1;
            const isPrimaryButton = isOnlyButton
              ? !treatSingleButtonAsPrimary
              : index !== 0;
            const buttonColor =
              button.color ?? (isPrimaryButton ? "primary" : "accent");
            const usesPrimaryStyle = buttonColor === "primary";

            return (
              <LegacyButton
                key={button.name}
                text={button.name}
                onClick={button.action}
                content="textIcon"
                size="small"
                className={`flex items-center ${
                  usesPrimaryStyle
                    ? "bg-primary py-2 px-4 w-full sm:w-auto justify-between"
                    : buttons?.length === 1 && !treatSingleButtonAsPrimary
                      ? "w-auto justify-between"
                      : "w-full sm:w-auto justify-between"
                } ${button.className ?? ""} mb-3`}
                color={buttonColor}
                icon={
                  <img
                    src={chevronRightButton}
                    alt="chevron"
                    className="w-3 h-3"
                  />
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default EventCard;
